import { SpeckleImportModel } from "../types/SpeckleImportModel";

export enum SpeckleImportStep {
  Account,
  Workspace,
  Project,
  Model,
  Version,
}

/**
 * Gets the cleared values when stepping back in the Speckle import wizard.
 * Clears values that belong to subsequent steps based on which step is jumped to.
 */
export function getClearedValuesForStep(
  step: SpeckleImportStep,
  currentValues: SpeckleImportModel,
): SpeckleImportModel {
  const stepFields: Record<SpeckleImportStep, Partial<SpeckleImportModel>> = {
    [SpeckleImportStep.Account]: {
      connectedAccountId: null,
      workspaceId: null,
      workspaceName: null,
      projectId: null,
      projectName: null,
      modelId: null,
      modelName: null,
      versionId: null,
    },
    [SpeckleImportStep.Workspace]: {
      workspaceId: null,
      workspaceName: null,
      projectId: null,
      projectName: null,
      modelId: null,
      modelName: null,
      versionId: null,
    },
    [SpeckleImportStep.Project]: {
      projectId: null,
      projectName: null,
      modelId: null,
      modelName: null,
      versionId: null,
    },
    [SpeckleImportStep.Model]: {
      modelId: null,
      modelName: null,
      versionId: null,
    },
    [SpeckleImportStep.Version]: {},
  };

  const clearedFields = stepFields[step];
  return step === SpeckleImportStep.Account
    ? (clearedFields as SpeckleImportModel)
    : { ...currentValues, ...clearedFields };
}
